import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { UnsavedChangesService } from './unsaved-changes-svc.ng';

export interface UnsavedChanges {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
    changeTrackingActive: boolean;
    setupTracking: () => void;
    takeDownTracking: () => void;
}

@Injectable({
    providedIn: 'root',
})
export class UnsavedChangesGuard implements CanDeactivate<UnsavedChanges> {
    constructor(private unsavedSvc: UnsavedChangesService) {}

    canDeactivate(target: UnsavedChanges): Observable<boolean> | Promise<boolean> | boolean {
        if (!this.unsavedSvc.hasTracker()) {
            return true;
        }

        const deactivateResult = target.canDeactivate ? target.canDeactivate() : true;

        return deactivateResult;
    }
}
